import { connectBaseApi, createRpcQuery, createRpcMutation, containerClient } from "@racoon/api";

const containerGroupApi = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listContainerGroups: createRpcQuery(build, containerClient, "listContainerGroups", {
      providesTags: ["ContainerGroup"],
    }),

    getContainerGroupById: createRpcQuery(build, containerClient, "getContainerGroupById", {
      providesTags: ["ContainerGroup"],
    }),

    // Container groups travel embedded in the pickup-location list, so every
    // mutation refreshes that list too, or the cascade would go stale. Only the
    // list: photos and by-id reads carry no container-group data.
    createContainerGroup: createRpcMutation(build, containerClient, "createContainerGroup", {
      invalidatesTags: ["ContainerGroup", { type: "PickupLocation" as const, id: "LIST" }],
    }),

    // The backend mirrors the schedule column into the schedule table.
    updateContainerGroup: createRpcMutation(build, containerClient, "updateContainerGroup", {
      invalidatesTags: [
        "ContainerGroup",
        "ContainerGroupSchedule",
        { type: "PickupLocation" as const, id: "LIST" },
      ],
    }),

    deleteContainerGroup: createRpcMutation(build, containerClient, "deleteContainerGroup", {
      invalidatesTags: [
        "ContainerGroup",
        "ContainerGroupSchedule",
        "Contact",
        { type: "PickupLocation" as const, id: "LIST" },
      ],
    }),

    listCompatibleContainerGroupsForTruck: createRpcQuery(
      build,
      containerClient,
      "listCompatibleContainerGroupsForTruck",
      {
        providesTags: ["ContainerGroup"],
      },
    ),
  }),
  overrideExisting: false,
});

export const {
  useListContainerGroupsQuery,
  useGetContainerGroupByIdQuery,
  useCreateContainerGroupMutation,
  useUpdateContainerGroupMutation,
  useDeleteContainerGroupMutation,
  useListCompatibleContainerGroupsForTruckQuery,
} = containerGroupApi;
